module.exports = __webpack_public_path__ + "static/img/adv3.7a68fdfe.png";